import { render, staticRenderFns } from "./IntegrationVariableView.vue?vue&type=template&id=55c580f6&scoped=true"
import script from "./IntegrationVariableView.vue?vue&type=script&lang=js"
export * from "./IntegrationVariableView.vue?vue&type=script&lang=js"
import style0 from "./IntegrationVariableView.vue?vue&type=style&index=0&id=55c580f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c580f6",
  null
  
)

export default component.exports